import { render } from "./DragDropPage.vue?vue&type=template&id=4645cf12&ts=true"
import script from "./DragDropPage.vue?vue&type=script&lang=ts"
export * from "./DragDropPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__